import { render, staticRenderFns } from "./ObservationsPage.vue?vue&type=template&id=3a15b724&scoped=true"
import script from "./ObservationsPage.vue?vue&type=script&lang=js"
export * from "./ObservationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15b724",
  null
  
)

export default component.exports